import { Component, effect, inject, input, OnInit, output, signal } from '@angular/core';
import { TranslationLanguagesEnum } from '@/common/translation/translation-languages-enum';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslationOrchestratorService } from '@/common/translation/translation-orchestrator.service';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-translation-language-select',
	standalone: true,
	imports: [MatFormField, MatSelect, MatOption, TranslatePipe, MatLabel, FormsModule],
	templateUrl: 'translation-language-select.component.html',
})
export class TranslationLanguageSelectComponent implements OnInit {
	readonly enabledLanguages = input<TranslationLanguagesEnum[]>([]);
	defaultLanguage = input(TranslationLanguagesEnum.POLISH);
	languageSelected = signal<TranslationLanguagesEnum>(null);
	onLanguageChange = output<TranslationLanguagesEnum>();

	protected readonly languageLabels: Record<TranslationLanguagesEnum, string> = {
		[TranslationLanguagesEnum.POLISH]: 'Polski',
		[TranslationLanguagesEnum.ENGLISH]: 'English',
		[TranslationLanguagesEnum.GERMAN]: 'Deutsche',
	};

	private readonly translationOrchestratorService: TranslationOrchestratorService =
		inject(TranslationOrchestratorService);

	constructor() {
		effect(() => {
			this.onLanguageChange.emit(this.languageSelected());
			this.translationOrchestratorService.load('translation', this.languageSelected());
		});
	}

	ngOnInit(): void {
		if (!this.enabledLanguages().includes(this.defaultLanguage())) {
			throw new Error('Default language is not set as an enabled language!');
		}
		this.languageSelected.set(this.defaultLanguage());
	}
}
